// # Academic Information Signup Component (Step 3)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import AuthHeader from '../../components/AuthHeader';
import './styles/academic.css';
import { LogoFade } from './more_components/auth_animation';
import SignupProgress from './more_components/progress_bar';

function SignupAcademic() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    university: '',
    phase: '',
    gpa: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const user = auth.currentUser;
      if (!user) throw new Error('No authenticated user');

      // # Get personal data from localStorage
      const personalData = JSON.parse(localStorage.getItem('personalData') || '{}');
      
      // # Update user document with academic data and progress
      await updateDoc(doc(db, 'users', user.uid), {
        ...personalData,
        ...formData,
        signupStep: 4,
        'metadata.updatedAt': new Date().toISOString()
      });

      localStorage.setItem('lastSignupStep', '4');
      navigate('/signup/photo');
    } catch (error) {
      console.error('Error saving academic data:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div>
      <AuthHeader />
      <SignupProgress currentStep={3} />
      <div className="sgnp_acd_academic-step">
        <div className="sgnp_acd_signup-logo-section">
          <LogoFade src="/icons/signup/logo512.png" />
        </div>
        <div className="sgnp_acd_signup-form-section">
          <div className="sgnp_acd_form-content">
            <h2>Academic Information</h2>
            <form onSubmit={handleSubmit}>
              <div className="sgnp_acd_form-group">
                <div className="sgnp_acd_input-group">
                  <label className="sgnp_acd_input-label sgnp_acd_required-field">University</label>
                  <input
                    className="sgnp_acd_input"
                    type="text"
                    name="university"
                    placeholder="Enter your university name"
                    value={formData.university}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="sgnp_acd_input-group">
                  <label className="sgnp_acd_input-label sgnp_acd_required-field">Current Phase</label>
                  <select 
                    className="sgnp_acd_select"
                    name="phase" 
                    value={formData.phase} 
                    onChange={handleChange} 
                    required
                  >
                    <option value="">Select Your Current Phase</option>
                    <option value="basic-science">Academic Phase (Basic Science)</option>
                    <option value="clinical-medicine">Clinical Phase (Clinical Medicine)</option>
                    <option value="intern">Intern</option>
                    <option value="new-graduate">New Graduate (&lt; 3 years)</option>
                    <option value="old-graduate">Old Graduate (&gt; 3 years)</option>
                  </select>
                </div>

                <div className="sgnp_acd_input-group">
                  <label className="sgnp_acd_input-label sgnp_acd_required-field">GPA</label>
                  <input
                    className="sgnp_acd_input"
                    type="number"
                    name="gpa"
                    placeholder="Enter your GPA"
                    value={formData.gpa}
                    onChange={handleChange}
                    step="0.01"
                    min="0"
                    max="4"
                    required
                  />
                </div>
              </div>
              <button type="submit" className="sgnp_acd_button">Continue</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupAcademic; 